import {combineLatest, merge} from 'rxjs';
import {map, scan} from 'rxjs/operators';
import {currencies$} from '@/config';
import {wsLogout$} from '@/user/auth-ws';
import {wmMsg$} from '@/raw/wm';
import type {ws, ReduceAction} from '@/types';

type WMMsg = ws.WMMsg;
type InvestmentAccountRaw = ws.InvestmentAccountRaw;

type Cache = Map<string, InvestmentAccountRaw>;
type Action = ReduceAction<Cache>;

const reset$ = wsLogout$.pipe(
  map(
    (): ReduceAction<Cache> => (cache: Cache) => {
      cache.clear();
      return cache;
    }
  )
);

const investmentsData$ = wmMsg$.pipe(map((data: WMMsg) => data.investments));

const investmentData$ = combineLatest([investmentsData$, currencies$]).pipe(
  map(([investmentsData, currencies]) =>
    investmentsData.filter((investment) => currencies.some((o) => o.currency === investment.currency))
  )
);

const action$ = investmentData$.pipe(
  map((investments: InvestmentAccountRaw[]): Action => {
    return function (cache: Cache) {
      investments.forEach((investment: InvestmentAccountRaw) => cache.set(investment.currency, investment));
      return cache;
    };
  })
);

export const investmentsAccountsCache$ = merge<Action[]>(action$, reset$).pipe(
  scan((p: Cache, c: Action) => c(p), new Map<string, InvestmentAccountRaw>())
);
